import { Routes, RouterModule } from '@angular/router';
import { SystemVersionsComponent } from './system-versions-header/system-versions.component';

const routes: Routes = [
    { path: '', component: SystemVersionsComponent}
  ];

  export const systemVersionsRouting = RouterModule.forChild(routes);
